module.exports = { "default": require("core-js/library/fn/object/is"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/core-js/object/is.js
// module id = 83
// module chunks = 2